import {Tooltip} from 'platform/components';
import {Text} from 'platform/foundation';
import {useFormatCurrency} from 'platform/locale';

import {forwardRef} from 'react';

import {useTooltipProps} from '../../hooks/useTooltipProps';
import {ICellRenderer, ICellRendererParams} from '../../types/AgGridTypes';
import {TooltipGetter} from '../../types/TooltipGetter';
import {getCellClassName} from '../../utils/getCellClassName';
import {getStylesToRender} from '../../utils/getStylesToRender';

export interface MoneyCellRendererProps extends ICellRendererParams {
  getTooltipProps?: TooltipGetter;
  decimalPlaces?: number;
}

function MoneyCellRendererComponent(props: MoneyCellRendererProps, _ref: React.Ref<ICellRenderer>) {
  const {getTooltipProps, data, node, colDef, decimalPlaces} = props;
  const className = getCellClassName(colDef);
  const formatCurrency = useFormatCurrency();

  const cellStyles = getStylesToRender(props);

  const value = props.getValue?.() ?? props.value;
  const cellValue = formatCurrency(value?.amount, value?.currency, decimalPlaces ?? 2);

  const tooltipProps = useTooltipProps(data, node, getTooltipProps);

  return (
    <Tooltip {...tooltipProps} label={cellValue}>
      {/* eslint-disable-next-line react/forbid-dom-props */}
      <div className={className}>
        <Text color={cellStyles?.textColor} noWrap={!colDef?.wrapText} size="small">
          {cellValue}
        </Text>
      </div>
    </Tooltip>
  );
}

export const MoneyCellRenderer = forwardRef<ICellRenderer, MoneyCellRendererProps>(
  MoneyCellRendererComponent
);
